import Axios from "axios"
import config from "../app.config"

export var mailServerService

export default mailServerService = {
    getListMailServerSentUser,
    getMailServers,
    getMailServer,
    createMailServer,
    deleteMailServers,
    updateMailServer,
    testConnection,
    getFullMailServers,
}

async function getListMailServerSentUser(data) {
    return await Axios.get(`${config.LOCAL_API_URL}/getListMailServerSentUser`)
        .then(response => {
            if(response.data) {
                return Promise.resolve(response.data);
            } else {
                return Promise.reject(response);
            }
        }).catch(error =>{
            return Promise.reject(error);
        })
}

async function getMailServers(params){
    return await Axios.get(`${config.LOCAL_API_URL}/mail-server`,{params: params})
        .then(response =>{
            return Promise.resolve(response.data)
        })
        .catch(error =>{
            return Promise.reject(error);
        })
}

async function getMailServer(id){
    return await Axios.get(`${config.LOCAL_API_URL}/mail-server/` + id)
    .then(response => {
        if(response.data.success || response.data.status) return Promise.resolve(response.data)
        else return Promise.reject(response.data)
    })
    .catch(error =>{
        return Promise.reject(error.response.data);
    })
}

async function createMailServer(params){
    return await Axios.post(`${config.LOCAL_API_URL}/mail-server`, params)
    .then(response => {
        if(response.data.success || response.data.status) return Promise.resolve(response.data)
        else return Promise.reject(response.data)
    })
    .catch(error =>{
        return Promise.reject(error.response.data);
    })
}

async function deleteMailServers(params){
    return await Axios.delete(`${config.LOCAL_API_URL}/mail-server`, {data: params})
    .then(response => {
        if(response.data.success || response.data.status) return Promise.resolve(response.data)
        else return Promise.reject(response.data)
    })
    .catch(error =>{
        return Promise.reject(error.response.data);
    })
}

async function updateMailServer(data){
    return await Axios.put(`${config.LOCAL_API_URL}/mail-server/` + data.id, data)
    .then(response => {
        if(response.data.success || response.data.status) return Promise.resolve(response.data)
        else return Promise.reject(response.data)
    })
    .catch(error =>{
        return Promise.reject(error.response.data);
    })
}

async function testConnection(params){
    return await Axios.post(`${config.LOCAL_API_URL}/check-mail-server`, params)
    .then(response => {
        if(response.data.success || response.data.status) return Promise.resolve(response.data)
        else return Promise.reject(response.data)
    })
    .catch(error =>{
        return Promise.reject(error.response.data);
    })
}

async function getFullMailServers(params){
    return await Axios.get(`${config.LOCAL_API_URL}/full-mail-server`,{params: params})
        .then(response =>{
            return Promise.resolve(response.data)
        })
        .catch(error =>{
            return Promise.reject(error);
        })
}